import { gql } from '@apollo/client';

//returns an address
export const PERSON_NAME_HISTORY = gql`
  query personNameHistory($personId: ID!, $originatorId: ID!){
    personNameHistory(personId: $personId, originatorId: $originatorId) {
      id
      createdAt
      lastUpdated
      updatedAt
      value
      personalAttribute {
        id
        firstName
        middleName
        lastName
      }
    }
  }
`;